import { ApiProperty } from '@nestjs/swagger';
import { IsNotEmpty, IsOptional } from 'class-validator';


export class ExpensesDTO {
  @ApiProperty()
  @IsNotEmpty()
  id: number;

  @ApiProperty()
  @IsNotEmpty()

  head: string;

  @ApiProperty()
  @IsNotEmpty()

  category: string;

  @ApiProperty()
  @IsNotEmpty()

  month: number;

  @ApiProperty()
  @IsNotEmpty()

  amount: number;

  @ApiProperty()
  @IsNotEmpty()
  createdUser: string ;


  @ApiProperty()
  @IsOptional()
  createdAt: Date;


  @ApiProperty()
  updatedAt: Date;

  @ApiProperty()
  @IsNotEmpty()
  updatedUser: string ;
}
